import { Button, Dialog, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";

export default function TaxTypesEditor(props : any) {

  /*=============================================
  VARIABLES FROM PROPS
  ============================================= */
  const {
    setLoading, 
    openEditor, 
    setOpenEditor, 
    type_id,
    loadList
  } = props;

  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar } = useSnackbar();
  /*============================================= */
  
  const [typeValues, setTypeValues] = useState<any>({
    name: ""
  });

  /*=======================================
  GET TYPE DETAILS IF TYPE_ID EXISTS
  =======================================*/
  useEffect(() => {
    if (type_id && openEditor) {
      setLoading(true);
      ApiRequest({
        method: 'GET',
        url: '/admin/taxes/types/details',
        query: { id: type_id },
        setResponse: (response: any) => {
          if (response) {
            setTypeValues({
              id: response.id,
              name: response.name || ""
            });
          }
          setLoading(false);
        }
      });
    } else if (openEditor) {
      setTypeValues({
        name: ""
      });
    }
  }, [openEditor, type_id]);

  /*=======================================
  SUBMIT FUNCTION
  =======================================*/
  const handleSubmit = () => {  
    if (!typeValues.name.trim()) {
      enqueueSnackbar('Name is required', { variant: 'error' });
      return;
    }

    setLoading(true);
    
    ApiRequest({
      method: 'POST',
      url: '/admin/taxes/types/addedit',
      body: {
        id: type_id || null,
        name: typeValues.name.trim()
      },
      setResponse: (response: any) => {
        if(response.status === "success"){
          enqueueSnackbar(type_id ? 'Tax type updated successfully' : 'Tax type created successfully', { variant: 'success' });
          setOpenEditor(false);
          loadList();
        } else {
          enqueueSnackbar(response.message || 'Error saving tax type', { variant: 'error' });
        }
        setLoading(false);
      }
    });
  };

  /*=======================================
  HANDLE INPUT CHANGE
  =======================================*/
  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setTypeValues({
      ...typeValues,
      [name]: value
    });
  };

  /*=======================================
  HANDLE CLOSE
  =======================================*/
  const handleClose = () => {
    setOpenEditor(false);
    setTypeValues({
      name: ""
    });
  };

  return (
    <>
      <Dialog 
        open={openEditor}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        PaperProps={{ sx: { borderRadius: "1.25rem", minWidth:"750px" } }}
      >
        <div className="DialogContainer">
          <div className="ModuleWrapper">
            <div className="boxContainerHeader">
              <div className="dialog_container_title">
                <h2 className="dialog_title">
                  {type_id ? "Edit Tax Type" : "Add Tax Type"}
                </h2>
              </div>
            </div>
            
            <div className="dialogFormContainer">
              <TextField
                name="name"
                label="Tax Type Name"
                value={typeValues.name}
                onChange={handleInputChange}
                fullWidth
                required
                placeholder="Enter tax type name"
                variant="outlined"
                size="small"
              />
            </div>
          </div>
        </div>

        <div className="dialogButtons">
          <Button
            onClick={handleSubmit}
            variant="contained"
            className="button_1"
          >
            {type_id ? "Save Changes" : "Add Type"}
          </Button>

          <Button
            onClick={handleClose}
            variant="contained"
            color="secondary"
            className="button_secondary"
          >
            Cancel
          </Button>
        </div>
      </Dialog>
    </>
  );
}
